module.exports = __webpack_public_path__ + "img/unit-hierarchy.272393c8.png";